import { render, staticRenderFns } from "./PromoCodeImportPopup.vue?vue&type=template&id=2055ef1f&scoped=true"
import script from "./PromoCodeImportPopup.vue?vue&type=script&lang=js"
export * from "./PromoCodeImportPopup.vue?vue&type=script&lang=js"
import style0 from "./PromoCodeImportPopup.vue?vue&type=style&index=0&id=2055ef1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2055ef1f",
  null
  
)

export default component.exports